<template>
  <div class="container pathways__subcomponent">
    <div class="columns is-centered is-not-vertical">
      <div class="column is-10-tablet is-8-desktop">
        <p class="title is-3 pathways-question__indicator">Question 5</p>
        <h2 class="title is-1">
          In the past three months, how often has the person’s alcohol and/or drug use caused them
          to be unable to do what’s normally expected of them?
        </h2>
        <p class="pathways__helpbox mt-24 mb-16">
          e.g. Showing up and doing their job, completing family responsibilities, socialising with
          friends etc.
        </p>
      </div>
    </div>
    <div class="columns is-centered is-not-vertical">
      <div class="column is-8-tablet">
        <div class="pathways__option-tight-container">
          <PathwaysOption label-text="Never">
            <input
              type="radio"
              name="never"
              value="never"
              v-model="impairment"
              @change="setNextDisabled(false)"
            />
          </PathwaysOption>
          <PathwaysOption label-text="Once or twice">
            <input
              type="radio"
              name="once-twice"
              value="once-twice"
              v-model="impairment"
              @change="setNextDisabled(false)"
            />
          </PathwaysOption>
          <PathwaysOption label-text="Monthly">
            <input
              type="radio"
              name="monthly"
              value="monthly"
              v-model="impairment"
              @change="setNextDisabled(false)"
            />
          </PathwaysOption>
          <PathwaysOption label-text="Weekly">
            <input
              type="radio"
              name="weekly"
              value="weekly"
              v-model="impairment"
              @change="setNextDisabled(false)"
            />
          </PathwaysOption>
          <PathwaysOption label-text="Daily or almost daily">
            <input
              type="radio"
              name="daily"
              value="daily"
              v-model="impairment"
              @change="setNextDisabled(false)"
            />
          </PathwaysOption>
          <PathwaysOption label-text="Don't know">
            <input
              type="radio"
              name="unknown"
              value="unknown"
              v-model="impairment"
              @change="setNextDisabled(false)"
            />
          </PathwaysOption>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import PathwaysOption from '@/components/pathways/PathwaysOption.vue';

const { mapActions } = createNamespacedHelpers('pathways');

export default {
  name: 'PathwaysQuestionOtherImpair',
  components: { PathwaysOption },
  computed: {
    impairment: {
      get() {
        return this.$store.state.pathways.responses.impairment;
      },
      set(value) {
        this.$store.dispatch('pathways/updateResponses', { impairment: value });
      },
    },
  },
  mounted() {
    this.setNextDisabled(!this.impairment);
  },
  methods: {
    ...mapActions({
      setNextDisabled: 'disableNext',
    }),
  },
};
</script>
